<template>
  <div id="log-in-modal">
    <div
      class="modal"
      :class="modalIsActive ? 'is-active' : ''"
    >
      <div
        class="modal-background"
        @click="toggleModal"
      />
      <div class="modal-card card">
        <section
          v-show="!isLoading"
          class="modal-card-body"
        >
          <log-in-form
            v-if="!isForgotPasswordFormVisible"
            @togglePasswordResetForm="handleTogglePasswordResetForm"
          />
          <reset-password-form v-else @toggleLoginForm="toggleLoginForm($event)" />
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import LogInForm from '@/components/Login/LogInForm';
import ResetPasswordForm from '@/components/Login/ResetPasswordForm';

export default {
  name: 'LogInModal',
  components: {
    LogInForm,
    ResetPasswordForm
  },
  props: {
    modalIsActive: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      isLoading: false,
      isForgotPasswordFormVisible: false
    };
  },
  methods: {
    toggleModal () {
      this.isLoading = false;
      this.isForgotPasswordFormVisible = false;
      this.$emit('toggleModal', false);
    },
    handleTogglePasswordResetForm () {
      this.isForgotPasswordFormVisible = true;
    },
    toggleLoginForm ($event) {
      this.isForgotPasswordFormVisible = !$event;
    }
  }
};
</script>

<style scoped lang="scss">
.modal-card-body {
  padding: 1.5rem 3rem;
}

@media screen and (min-width: 640px) {
  .modal-card {
    max-width: 400px;
  }
}
</style>
